function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ReportManagementModel } from '../model/report_management_model';
import ModalReport from '../components/modalReport/ModalReport.vue';
import module_dashboard_service from '@/apps/data-platform/services/reports/module_dashboard_service';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
var ReportManagementPage = /*#__PURE__*/function (_Vue) {
  function ReportManagementPage() {
    var _this;
    _classCallCheck(this, ReportManagementPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ReportManagementPage, [].concat(args));
    _defineProperty(_this, "utils", utils);
    _defineProperty(_this, "grid_data_info", []);
    _defineProperty(_this, "module", void 0);
    _defineProperty(_this, "is_admin", void 0);
    _defineProperty(_this, "selectedReport", null);
    //#region Model
    _defineProperty(_this, "model", new ReportManagementModel());
    return _this;
  }
  _inherits(ReportManagementPage, _Vue);
  return _createClass(ReportManagementPage, [{
    key: "created",
    value: //#endregion
    //#region Lifecycle
    function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.init();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }() //#endregion
    //#region Init
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.loadFilter();
            case 1:
              _context2.n = 2;
              return this.loadGridData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "loadFilter",
    value: function () {
      var _loadFilter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function loadFilter() {
        return _loadFilter.apply(this, arguments);
      }
      return loadFilter;
    }()
  }, {
    key: "onShowFilter",
    value: function onShowFilter() {
      this.model.buttons.show_filter = !this.model.buttons.show_filter;
    }
  }, {
    key: "onCleanFilter",
    value: function onCleanFilter() {
      this.model.filter = {
        title: undefined,
        description: undefined
      };
      this.model.grid.data = this.grid_data_info;
    }
  }, {
    key: "loadGridData",
    value: function () {
      var _loadGridData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var response, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.showLoading(true);
              _context4.p = 1;
              _context4.n = 2;
              return module_dashboard_service.getAllReport({
                module: this.module
              });
            case 2:
              response = _context4.v;
              if (response.success) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              this.model.grid.key++;
              this.grid_data_info = _toConsumableArray(response.data);
              this.model.grid.data = response.data;
              this.model.grid.pagination.total = response.data.length;
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
              console.error(_t);
            case 5:
              _context4.p = 5;
              this.showLoading(false);
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 4, 5, 6]]);
      }));
      function loadGridData() {
        return _loadGridData.apply(this, arguments);
      }
      return loadGridData;
    }()
  }, {
    key: "onSearch",
    value: function onSearch() {
      var titleRaw = this.model.filter.title;
      var descriptionRaw = this.model.filter.description;
      var titleFilter = titleRaw ? titleRaw.trim().toLowerCase() : '';
      var descriptionFilter = descriptionRaw ? descriptionRaw.trim().toLowerCase() : '';
      if (!titleFilter && !descriptionFilter) {
        this.$toast.error(this.$t('report_management.general.filter_required'));
        return;
      }
      this.model.grid.data = this.grid_data_info.filter(function (item) {
        var itemTitle = item.title ? item.title.trim().toLowerCase() : '';
        var itemDescription = item.description ? item.description.trim().toLowerCase() : '';
        return titleFilter && itemTitle.includes(titleFilter) || descriptionFilter && itemDescription.includes(descriptionFilter);
      });
    }
  }, {
    key: "showLoading",
    value: function showLoading(show) {
      this.$store.commit('app/setShowLoading', show);
    }
    //#endregion
    //#region ComputedGrid
  }, {
    key: "title",
    get: function get() {
      if (this.is_admin) {
        return this.$t('report_management.report_management_page.title_admin');
      }
      return this.$t('report_management.report_management_page.title_user');
    }
  }, {
    key: "getClassTable",
    get: function get() {
      return this.model.buttons.show_filter ? 'col-md-9 col-sm-12' : 'col-sm-12';
    }
  }, {
    key: "loadGridHeader",
    get: function get() {
      return this.model.grid.headers(this.$i18n, this.is_admin);
    }
    //#endregion
  }, {
    key: "deleteReport",
    value: function () {
      var _deleteReport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(confirm) {
        var modal, response, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              modal = this.$refs[this.model.modal_report_confirmation_delete.name];
              modal.isOpen = false;
              if (!(!confirm || !this.selectedReport || !this.selectedReport.id)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              this.showLoading(true);
              _context5.p = 2;
              _context5.n = 3;
              return module_dashboard_service.deleteReport({
                module: this.module,
                id: this.selectedReport.id
              });
            case 3:
              response = _context5.v;
              if (!response.success) {
                _context5.n = 5;
                break;
              }
              tasks.toast.success(this.$t('report_management.general.confirm_delete_message'));
              _context5.n = 4;
              return this.loadGridData();
            case 4:
              _context5.n = 6;
              break;
            case 5:
              tasks.toast.error(this.$t('report_management.general.error_proccessing'), this.$t('report_management.general.error_title'));
            case 6:
              _context5.n = 8;
              break;
            case 7:
              _context5.p = 7;
              _t2 = _context5.v;
              console.error('Error al eliminar el reporte:', _t2);
              tasks.toast.error(this.$t('report_management.general.error_proccessing'), this.$t('report_management.general.error_title'));
            case 8:
              _context5.p = 8;
              this.showLoading(false);
              return _context5.f(8);
            case 9:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 7, 8, 9]]);
      }));
      function deleteReport(_x) {
        return _deleteReport.apply(this, arguments);
      }
      return deleteReport;
    }()
  }, {
    key: "openModalConfirmationDelete",
    value: function openModalConfirmationDelete(item) {
      this.selectedReport = item;
      var modal = this.$refs[this.model.modal_report_confirmation_delete.name];
      modal.onOpen();
    }
  }, {
    key: "openReport",
    value: function openReport(item) {
      this.$router.push({
        name: "report_management_view",
        params: {
          report: item
        }
      });
    }
  }, {
    key: "openModalReport",
    value: function openModalReport(item) {
      var is_new = false;
      if (!item) {
        item = {
          id: 'report_' + new Date().getTime(),
          //code: '1020',
          //title: 'Reporte ' + Math.floor(Math.random() * 1000),
          //type: 'POWERBI',
          //description:
          //'Descripción de reporte ' + Math.floor(Math.random() * 1000),
          //all_permission: true,
          organizations: [],
          //link: 'https://example.com/report/' + Math.floor(Math.random() * 10000),
          //update_hours: ['02:00', '04:00', '06:00'],
          maintenance: false,
          module: this.module.toString()
        };
        is_new = true;
      }
      var modal = this.$refs[this.model.modal_name];
      modal.onOpen(item, is_new);
    }
  }]);
}(Vue);
__decorate([Prop({
  type: String,
  required: false,
  default: 'audience-management-campaign'
})], ReportManagementPage.prototype, "module", void 0);
__decorate([Prop({
  type: Boolean,
  required: false,
  default: false
})], ReportManagementPage.prototype, "is_admin", void 0);
ReportManagementPage = __decorate([Component({
  components: {
    ModalReport: ModalReport
  }
})], ReportManagementPage);
export default ReportManagementPage;